import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setActiveAssetAssetCategoryDropDown, setActiveAssetCostCenterDropDown, setActiveAssetEqClassCodeDropDown, setActiveAssetGLCategoryDropDown, setActiveAssetMakeDropDown, setActiveAssetModelDropDown, setActiveAssetStateDropDown, setActiveAssetYearDropDown } from 'Store/AssetManagement/ActiveAssetDropDown/ActiveAssetDropDownAction';
import { GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN, GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN, GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN, GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN, GET_ACTIVE_ASSET_MAKE_DROP_DOWN, GET_ACTIVE_ASSET_MODEL_DROP_DOWN, GET_ACTIVE_ASSET_STATE_DROP_DOWN, GET_ACTIVE_ASSET_YEAR_DROP_DOWN } from 'Store/AssetManagement/ActiveAssetDropDown/ActiveAssetDropDownType';

function* getActiveAssetCostCenterSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/costcenter`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetCostCenterDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetCostCenterDropDown(null))
    }
}

function* getActiveAssetMakeSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/make`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetMakeDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetMakeDropDown(null))
    }
}

function* getActiveAssetModelSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/model`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetModelDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetModelDropDown(null))
    }
}

function* getActiveAssetYearSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/year`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetYearDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetYearDropDown(null))
    }
}

function* getActiveAssetGlCategorySaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/category`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetGLCategoryDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetGLCategoryDropDown(null))
    }
}

function* getActiveAssetAssetCategorySaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/assetcategory`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetAssetCategoryDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetAssetCategoryDropDown(null))
    }
}

function* getActiveAssetEqClassCodeSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/equipmentclasscode`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetEqClassCodeDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetEqClassCodeDropDown(null))
    }
}

function* getActiveAssetStateSaga(assessment: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/grid/dropdown/state`,
            apiMethod: apiMethod.GET,
            payload: assessment.assessment
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setActiveAssetStateDropDown(response))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetStateDropDown(null))
    }
}

function* watchCreateAssement() {
    yield takeEvery(GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN, getActiveAssetCostCenterSaga)
    yield takeEvery(GET_ACTIVE_ASSET_MAKE_DROP_DOWN, getActiveAssetMakeSaga)
    yield takeEvery(GET_ACTIVE_ASSET_MODEL_DROP_DOWN, getActiveAssetModelSaga)
    yield takeEvery(GET_ACTIVE_ASSET_YEAR_DROP_DOWN, getActiveAssetYearSaga)
    yield takeEvery(GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN, getActiveAssetGlCategorySaga)
    yield takeEvery(GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN, getActiveAssetAssetCategorySaga)
    yield takeEvery(GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN, getActiveAssetEqClassCodeSaga)
    yield takeEvery(GET_ACTIVE_ASSET_STATE_DROP_DOWN, getActiveAssetStateSaga)
}

export default function* combinedSaga() {
    yield all([
        watchCreateAssement()
    ])
}